import BaseService from './baseService';

class ApiKey extends BaseService {
  	async getApiKeys(opts = {}) {
		  this.endPoint = '/api-keys';
		  return this.get(opts);
    }
    async storeApiKeys(opts = {}) {
      this.endPoint = '/api-keys';
      return this.post(opts);
    }
    async deleteApiKeys(id, opts = {}){
      this.endPoint = '/api-keys';
      return this.delete(id, opts);
    }
}

export default new ApiKey();